import RoleView from "../../Navigation/RoleView";
import TeachrHomeV2 from "../../App/HomeV2/TeachrHomeV2";
import ClientHomeV2 from "../../App/ClientV2/ClientHomeV2";

/**
 * Accueil du tableau de bord commun, version repensée : la vue prof est
 * `TeachrHomeV2` (maquette 7a), la vue client `ClientHomeV2` (maquette 12b).
 * Les anciennes pages (`HomePage`, `TeachrHome`, `AllBordTab`, `ClientHome`)
 * sont conservées dans le code.
 */
const HomeV2Page = () => (
    <RoleView prof={<TeachrHomeV2 />} client={<ClientHomeV2 />} />
);

export default HomeV2Page;
